import React from 'react';
import { Link } from 'wouter';
import { Instagram, Linkedin, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-black text-white py-12 px-4 sm:px-6 lg:px-10 mt-auto border-t border-white/5">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
          <h3 className="font-serif font-bold text-2xl tracking-tighter uppercase text-white">
            Ajjas<span className="serif italic font-normal normal-case tracking-normal ml-1 text-spice-accent">Masala</span>
          </h3>
          <div className="flex items-center gap-4">
            <a href="#" className="p-2 bg-white/5 rounded-xl hover:bg-spice-accent transition-all hover:scale-110">
              <Instagram className="w-4 h-4 text-white" />
            </a>
            <a href="#" className="p-2 bg-white/5 rounded-xl hover:bg-spice-accent transition-all hover:scale-110">
              <Linkedin className="w-4 h-4 text-white" />
            </a>
            <a href="#" className="p-2 bg-white/5 rounded-xl hover:bg-spice-accent transition-all hover:scale-110">
              <Twitter className="w-4 h-4 text-white" />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
          <div className="text-center md:text-right">
            <p className="text-[10px] text-white uppercase font-black tracking-[0.2em] mb-1">+91 63600 37355</p>
            <p className="text-[10px] text-spice-accent font-bold lowercase tracking-wider">enquiries@ajjasfoods.shop</p>
          </div>
          <p className="text-[9px] text-white/30 uppercase tracking-[0.3em] font-black">&copy; {new Date().getFullYear()} Ajjas Masala</p>
        </div>
      </div>
    </footer>
  );
}
